import { CSSObject } from '@emotion/core';

import { scale } from '@scripts/gds';

import { scrollbarStyles } from '../../../../../../styles';

export const containerStyles: CSSObject = {
    marginTop: scale(3),
};

export const getBrandContainerStyles = (isExpanded: boolean): CSSObject => ({
    marginTop: '8px',
    paddingRight: '3px',
    ...(isExpanded && {
        maxHeight: '368px',
        overflowY: 'auto',
        overscrollBehavior: 'auto',
        ...scrollbarStyles.narrow,
    }),
});
